import styled, { css, keyframes } from 'styled-components'

const reticencias = keyframes`
  0% { clip-path: inset(0 100% 0 0); }
  25% { clip-path: inset(0 66% 0 0); }
  50% { clip-path: inset(0 33% 0 0); }
  75% { clip-path: inset(0 0 0 0); }
`

const correr = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(350%); }
`

const aparecer0 = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const aparecer = keyframes`
  to { opacity: 1; }
`

export const Loader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin: 100px auto;
  /* resposta rápida não chega a mostrar nada */
  opacity: 0;
  animation: ${aparecer} 0.2s ease 0.3s forwards;

  .texto {
    color: var(--yrm-text-3);
    font-size: 13px;
  }

  /* reticências entrando uma a uma; a largura fixa não deixa o texto dançar */
  .texto::after {
    content: '...';
    display: inline-block;
    width: 1.1em;
    text-align: left;
    animation: ${reticencias} 1.5s steps(1) infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    .texto::after {
      animation: none;
    }
  }

  ${({ $compacto }) => $compacto && css`
    gap: 10px;
    margin: 24px auto;
    .yrm-marca { --yrm-marca-largura: 92px; }
  `}

  ${({ $flutuante }) => $flutuante && css`
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 900;
    margin: 0;
    padding: 20px 28px;
    border-radius: 12px;
    background: var(--yrm-surface);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.16);
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0;
    animation: ${aparecer} 0.2s ease 0.25s forwards;
  `}
`

// Só a página: o menu e a barra do topo continuam livres
export const Global = styled.div`
  position: absolute;
  inset: 0;
  z-index: 900;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: color-mix(in srgb, var(--yrm-bg) 40%, transparent);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  pointer-events: none;
  animation: ${aparecer0} 0.18s ease-out;

  .yrm-marca {
    --yrm-marca-largura: 200px;
  }

  .texto {
    color: var(--yrm-text-2);
    font-size: 14px;
    font-weight: 500;
  }

  .texto::after {
    content: '...';
    display: inline-block;
    width: 1.1em;
    text-align: left;
    animation: ${reticencias} 1.5s steps(1) infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    .texto::after {
      animation: none;
    }
  }
`

export const Barra = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 900;
  height: 3px;
  overflow: hidden;
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    inset: 0 auto 0 0;
    width: 30%;
    border-radius: 3px;
    background: #d6a93a;
    animation: ${correr} 1.1s ease-in-out infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      width: 100%;
      animation: none;
    }
  }
`
